// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unit-content {
  margin-left: 10px;
  padding-left: 10px;
  border-left: 3px solid var(--ons-color-primary);
}

.unit {
  display: flex;
}
.unit .col {
  position: relative;
  color: black;
  font-size: 14px;
  text-align: center;
  padding: 0 3px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.unit .col-name {
  width: 35%;
  text-align: left;
  justify-content: flex-start;
  align-items: center;
}
.unit .col-name ion-reorder {
  margin-right: 7px;
}
.unit .col-rirs {
  width: 10%;
}
.unit .col-sets {
  width: 10%;
}
.unit .col-reps {
  width: 20%;
}
.unit .col-info {
  width: 25%;
}
.unit .col-actions {
  width: 50px;
  min-width: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.unit .col-actions ion-icon {
  cursor: pointer;
  font-size: 18px;
}
.unit .col-actions ion-icon.delete {
  color: var(--ons-color-red);
}
.unit .col-actions ion-icon.edit {
  font-size: 16px;
  color: var(--ons-color-green);
}
.unit .info {
  margin-right: 5px;
  display: flex;
  align-items: center;
}
.unit .watermark-edit {
  position: absolute;
  right: 0;
  font-size: 9px;
  color: var(--ons-color-green);
}

@media only screen and (min-width: 600px) {
  .unit .watermark-edit {
    font-size: 14px;
    color: var(--ons-color-green);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/training-plan-overview/training-plan-overview-sheet/training-plan-overview-unit/training-plan-overview-unit.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,kBAAA;EACA,+CAAA;AACJ;;AAEA;EACI,aAAA;AACJ;AACI;EACI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACR;AACQ;EACI,UAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;AACZ;AACY;EACI,iBAAA;AAChB;AAEQ;EACI,UAAA;AAAZ;AAEQ;EACI,UAAA;AAAZ;AAEQ;EACI,UAAA;AAAZ;AAEQ;EACI,UAAA;AAAZ;AAEQ;EACI,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAAZ;AAEY;EACI,eAAA;EACA,eAAA;AAAhB;AAEgB;EACI,2BAAA;AAApB;AAEgB;EACI,eAAA;EACA,6BAAA;AAApB;AAKI;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;AAHR;AAMI;EACI,kBAAA;EACA,QAAA;EACA,cAAA;EACA,6BAAA;AAJR;;AAQA;EAEQ;IACI,eAAA;IACA,6BAAA;EANV;AACF","sourcesContent":[".unit-content {\n    margin-left: 10px;\n    padding-left: 10px;\n    border-left: 3px solid var(--ons-color-primary);\n}\n\n.unit {\n    display: flex;\n\n    .col {\n        position: relative;\n        color: black;\n        font-size: 14px;\n        text-align: center;\n        padding: 0 3px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        &-name {\n            width: 35%;\n            text-align: left;\n            justify-content: flex-start;\n            align-items: center;\n\n            ion-reorder {\n                margin-right: 7px;\n            }\n        }\n        &-rirs {\n            width: 10%;\n        }\n        &-sets {\n            width: 10%;\n        }\n        &-reps {\n            width: 20%;\n        }\n        &-info {\n            width: 25%;\n        }\n        &-actions {\n            width: 50px;\n            min-width: 50px;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n\n            ion-icon {\n                cursor: pointer;\n                font-size: 18px;\n\n                &.delete {\n                    color: var(--ons-color-red);\n                }\n                &.edit {\n                    font-size: 16px;\n                    color: var(--ons-color-green);\n                }\n            }\n        }\n    }\n    .info {\n        margin-right: 5px;\n        display: flex;\n        align-items: center;\n    }\n\n    .watermark-edit {\n        position: absolute;\n        right: 0;\n        font-size: 9px;\n        color: var(--ons-color-green);\n    }\n}\n\n@media only screen and (min-width: 600px) {\n    .unit {\n        .watermark-edit {\n            font-size: 14px;\n            color: var(--ons-color-green);\n        }\n    }\n\n    \n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
